import { render, staticRenderFns } from "./registered.vue?vue&type=template&id=ad101fae&scoped=true&"
import script from "./registered.vue?vue&type=script&lang=js&"
export * from "./registered.vue?vue&type=script&lang=js&"
import style0 from "./registered.vue?vue&type=style&index=0&id=ad101fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad101fae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad101fae')) {
      api.createRecord('ad101fae', component.options)
    } else {
      api.reload('ad101fae', component.options)
    }
    module.hot.accept("./registered.vue?vue&type=template&id=ad101fae&scoped=true&", function () {
      api.rerender('ad101fae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/registered.vue"
export default component.exports